module.exports = __webpack_public_path__ + "img/coupon.6d291b9b.png";